<template>
  <v-container v-if="template"
               fluid
               :style="containerHeight">
    <PageTitle>
      <div class="d-flex align-center">
        <v-btn :to="{name: 'admin.share_template.edit', params: {templateID: template.id}}"
               class="mr-2">
          &laquo; Back
        </v-btn>
        <div class="text-h5">
          {{ template.name }}
        </div>
      </div>

      <template v-slot:buttons>
        <v-btn @click.prevent="saveDesign"
               color="primary"
               :disabled="form.busy"
               class="mr-2">
          Save
        </v-btn>

        <v-menu offset-y bottom
                :disabled="form.busy">
          <template v-slot:activator="{on, attrs}">
            <v-btn v-on="on"
                   v-bind="attrs"
                   class="mr-2">
              Actions
              <v-icon right>
                fal fa-fw fa-chevron-down
              </v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item :href="template.send_email_url"
                         target="_blank">
              <v-list-item-content>
                <v-list-item-title>
                  Send Test
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <ShareTemplateImageDialog :template="template">
              <template #activator="{ on, attrs, openDialog }">
                <v-list-item v-bind="attrs"
                             v-on="on"
                             @click="openDialog">
                  <v-list-item-title>
                    Quick View
                  </v-list-item-title>
                </v-list-item>
              </template>
            </ShareTemplateImageDialog>
            <v-list-item v-if="1===2"
                         :to="{name: 'admin.share_template.edit', params: {templateID: template.id}}">
              <v-list-item-content>
                <v-list-item-title>
                  Edit Template
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name: 'admin.share_template.show', params: {templateID: template.id}}" exact>
              <v-list-item-content>
                <v-list-item-title>
                  Performance
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="canTestEmailTemplates && form.html_body"
                         :to="{name: 'admin.mailgun.email_preview.create', query: {template_id: template.id}}">
              <v-list-item-content>
                <v-list-item-title>
                  Create Email Preview Test
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="template.can_be_copied"
                         :to="{name: 'admin.share_template.create', query: {source: template.id}}">
              <v-list-item-content>
                <v-list-item-title>
                  Copy Template
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="template.can_be_copied && isOnOtherTeams"
                         :to="{name: 'admin.share_template.copy_to_team', params: {templateID: template.id}}">
              <v-list-item-content>
                <v-list-item-title>
                  Copy to Another Team
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click.prevent="showUploadDialog">
              <v-list-item-content>
                <v-list-item-title>
                  Upload Design
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name: 'admin.share_template.audit_trail', params: {templateID: template.id}}">
              <v-list-item-content>
                <v-list-item-title>
                  Audit Trail
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn class="mr-2"
                   v-on="on"
                   :disabled="form.busy">
              Export
              <v-icon right>
                fal fa-fw fa-chevron-down
              </v-icon>
            </v-btn>
          </template>
          <v-list dense
                  :disabled="form.busy">
            <v-list-item @click.prevent="copyHTML">
              <v-list-item-icon class="mr-1">
                <v-icon small>
                  fal fa-fw fa-copy
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Copy HTML to Clipboard
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click.prevent="copyJSON">
              <v-list-item-icon class="mr-1">
                <v-icon small>
                  fal fa-fw fa-copy
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Copy Design to Clipboard
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click.prevent="downloadHTML">
              <v-list-item-icon class="mr-1">
                <v-icon small>
                  fal fa-fw fa-download
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Download HTML
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click.prevent="downloadJSON">
              <v-list-item-icon class="mr-1">
                <v-icon small>
                  fal fa-fw fa-download
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Download Design
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click.prevent="downloadPDF">
              <v-list-item-icon class="mr-1">
                <v-icon small>
                  fal fa-fw fa-file-pdf
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Download PDF
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-btn href="https://help.mobilelocker.com/article/126-build-a-template-using-unlayer-editor"
               target="_blank"
               class="mr-2"
               :disabled="form.busy">
          Help
        </v-btn>
      </template>
    </PageTitle>

    <v-toolbar flat
               dense
               tile>
      <v-tabs v-model="selectedTab"
              @change="updateFromDesign">
        <v-tab>
          Design
        </v-tab>
        <v-tab>
          HTML
        </v-tab>
        <v-tab>
          JSON
        </v-tab>
      </v-tabs>
    </v-toolbar>
    <v-tabs-items v-model="selectedTab"
                  class="full-width"
                  style="height: calc(100vh - 214px); overflow-y: auto;">

      <v-tab-item class="full-width"
                  style="height: calc(100vh - 214px);">
        <EmailEditor ref="emailEditor"
                     :editor-id="this.unlayerOptions.id"
                     @load="editorLoaded"
                     :options="unlayerOptions"
                     style="height: calc(100vh - 214px);"
                     :tools="tools">
        </EmailEditor>
      </v-tab-item>

      <v-tab-item class="full-width">
        <div class="pa-4 text-caption">
          You cannot edit the HTML here. Use the design tab.
        </div>
        <codemirror v-model="form.html_body"
                    :options="htmlOptions">
        </codemirror>
      </v-tab-item>

      <v-tab-item class="full-width">
        <div class="pa-4 text-caption">
          You cannot edit the JSON here. Use the design tab.
        </div>

        <codemirror v-model="designJSON"
                    :options="jsonOptions">
        </codemirror>
      </v-tab-item>

    </v-tabs-items>
    <media-library-dialog v-if="1===2"
                          :dialog="mediaDialog"
                          @image-selected="imageSelected">
    </media-library-dialog>

    <v-dialog v-if="uploadDialog"
              v-model="uploadDialog"
              width="485px">
      <v-form @submit.prevent="uploadJSON"
              :disabled="uploadForm.busy">
        <v-card flat
                tile>
          <v-card-title>
            Upload New Design
          </v-card-title>
          <v-card-text>
            <p>
              Replace the design with the JSON file saved on your computer.
            </p>
            <v-file-input v-model="uploadForm.file"
                          label="Unlayer JSON file"
                          placeholder="Select the JSON file from your computer"
                          accept="application/json"
                          outlined
                          dense
                          :error-messages="uploadForm.errors.get('file')">
            </v-file-input>
          </v-card-text>
          <v-card-actions class="px-4">
            <v-btn type="submit"
                   color="primary"
                   tile
                   :disabled="uploadForm.busy || !uploadForm.file">
              Upload
            </v-btn>
            <v-btn @click.prevent="closeUploadDialog"
                   :disabled="uploadForm.busy"
                   text>
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>
<style lang="scss">
.unlayer-editor {
  display: flex;
  flex-direction: column;

  iframe {
    flex: 1;
  }
}

.vue-codemirror {
  width: 100%;

  .CodeMirror {
    height: auto;
  }
}
</style>
<script>
import {mapGetters} from 'vuex';
import {EmailEditor} from 'vue-email-editor';
import {isArray} from 'lodash';
import {Form} from 'vform';
import shareTemplateService from '../../../../ml/services/shareTemplateService';
import clipboardService from "../../../../ml/services/clipboardService";
import Codemirror from '../share_templates/components/CodeMirror';
import teamAssetService from "../../../../ml/services/teamAssetService";
import MediaLibraryDialog from './components/MediaLibraryDialog';
import PageTitle from '../../components/PageTitle.vue';
import htmlService from '../../services/htmlService';
import fileUploadService from '../../services/fileUploadService';
import ShareTemplateImageDialog from '../share_templates/components/ShareTemplateImageDialog.vue';

/**
 * @see https://docs.unlayer.com/docs/vue-component
 */
export default {
  components: {
    ShareTemplateImageDialog,
    PageTitle,
    Codemirror,
    EmailEditor,
    MediaLibraryDialog,
  },
  data() {
    return {
      projectID: 20637,
      htmlOptions: { // MLD-2620
        autoCloseTags: true,
        extraKeys: {'Ctrl-Space': 'autocomplete'},
        foldGutter: true,
        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter', 'CodeMirror-lint-markers'],
        lineNumbers: true,
        lineWrapping: true,
        lint: true,
        matchTags: {bothTags: true},
        mode: 'htmlmixed',
        readOnly: true,
        theme: 'default',
      },
      jsonOptions: { // MLD-2620
        autoCloseTags: true,
        extraKeys: {'Ctrl-Space': 'autocomplete'},
        foldGutter: true,
        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter', 'CodeMirror-lint-markers'],
        lineNumbers: true,
        lineWrapping: true,
        lint: true,
        matchTags: {bothTags: true},
        mode: 'application/json',
        readOnly: true,
        theme: 'default',
      },
      form: new Form({
        design: null,
        html_body: null,
        text_body: null,
      }),
      selectedTab: 0,
      template: null,
      tools: {}, // @see https://docs.unlayer.com/docs/tools
      // MLD-2949 - not used right now
      images: [],
      mediaDialog: false,
      mediaDoneCallback: null,
      uploadDialog: false,
      uploadForm: new Form({ // MLD-6456
        file: null,
      })
    }
  },
  computed: {
    ...mapGetters([
      'canTestEmailTemplates',
      'isOnOtherTeams',
      'team',
      'user',
    ]),
    dataURI() { // MLD-5954
      return htmlService.dataURI(this.form.html_body);
    },
    containerHeight() { // MLD-5625
      /*if (this.selectedTab === 0) {
        return 'height: calc(100vh - 94px);';
      }*/
      return null;
    },
    unlayerOptions() {
      return {
        id: 'unlayer_editor',
        projectId: 20637,
        // @see https://docs.unlayer.com/docs/custom-js-css#custom-css
        // customCSS: [this.template.css_url],
        displayMode: 'email',
        // MLD-5950 - @see https://docs.unlayer.com/page/introducing-new-unlayer-editor
        version: 'latest',
        appearance: {
          theme: 'modern_light',
        },
        features: { // @see https://docs.unlayer.com/docs/features
          smartMergeTags: false, // MLD-3972 @see https://docs.unlayer.com/docs/merge-tags#smart-merge-tags
          stockImages: { // @see https://docs.unlayer.com/docs/features#stock-images
            enabled: false,
          },
          userUploads: true, // @see https://docs.unlayer.com/docs/features#user-uploads
        },
        mergeTagsConfig: {
          sort: false,
        },
        safeHtml: true, // Sanitizes HTML output to prevent executable JavaScript from being inserted.
        mergeTags: { // @see https://docs.unlayer.com/docs/merge-tags
          recipient: {
            name: 'Recipient',
            mergeTags: {
              conditional_greeting: {
                name: 'Conditional Greeting',
                value: '{% if recipient.greeting %}Hello {{ recipient.greeting }},{% else %}Hello,{% endif %}',
                sample: 'Hello Dr. Smith OR Hello',
              },
              greeting: {
                name: 'Greeting',
                value: '{{ recipient.greeting }}',
                sample: 'Dr. Smith OR John Smith'
              },
              salutation: {
                name: 'Salutation',
                value: '{{ recipient.salutation }}',
                sample: 'Dr. OR Mr. OR Mrs. OR Prof.'
              },
              first_name: {
                name: 'First Name',
                value: '{{ recipient.first_name }}',
                sample: 'John',
              },
              last_name: {
                name: 'Last Name',
                value: '{{ recipient.last_name }}',
                sample: 'Smith',
              },
              name: {
                name: 'Full Name',
                value: '{{ recipient.name }}',
                sample: 'John Smith',
              },
              email: {
                name: 'Email',
                value: '{{ recipient.email }}',
                sample: 'john.smith@customer.com',
              },
            },
          },
          user: {
            name: 'User',
            mergeTags: {
              first_name: {
                name: 'First Name',
                value: '{{ user_first_name }}',
                sample: 'Suzy',
              },
              last_name: {
                name: 'Last Name',
                value: '{{ user_last_name }}',
                sample: 'Smith',
              },
              email: {
                name: 'Email',
                value: '{{ user_email }}',
                sample: 'suzy.smith@company.com'
              },
              phone: {
                name: 'Phone Number',
                value: '{{ user_phone }}',
                sample: '(555)-333-5555',
              },
              phone_raw: { // MLD-4632
                name: 'Raw Phone Number',
                value: '{{ user_phone_raw }}',
                sample: '5553335555',
              },
              phone_extension: {
                name: 'Phone Number Extension',
                value: '{{ user_phone_extension }}',
                sample: 'x1234',
              },
              photo_url: {
                name: 'Photo URL',
                value: '{{ user_photo_url }}',
                sample: 'https://teams.mobilelocker.com/demo_team/assets/users/mark_stralka_256x256.jpg',
              },
              signature: {
                name: 'Signature',
                value: '{{ user_signature }}',
                sample: 'The user\'s full signature',
              },
            },
          },
        },
        specialLinks: [ // @see https://docs.unlayer.com/docs/special-links
          {
            name: 'Mobile Locker Unsubscribe URL',
            href: '{{ team_unsubscribe_url }}',
            target: '_blank',
          },
        ],
        user: { // @see https://docs.unlayer.com/docs/security#setup-identity-verification
          id: this.user.id,
          signature: this.user.unlayer_signature,
          name: this.user.name,
          email: this.user.email,
        }
      }
    },
    designJSON: {
      get() {
        return JSON.stringify(this.form.design, null, 4);
      },
      set() {

      },
    },
    editor() {
      return this.$refs.emailEditor.editor;
    },
    templateID() {
      return parseInt(this.$route.params.templateID);
    },
    downloadFilename() { // MLD-7684
      return `MobileLocker-EmailTemplate-${this.template.id}_${Date.now()}`;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.images = await teamAssetService.getAllImages().catch(() => {
      });
      shareTemplateService.getTemplate(this.templateID)
        .then(async data => {
          this.setTemplateFromData(data);
        })
    },
    setTemplateFromData(data) {
      this.form.design = data.design;
      this.form.html_body = data.html_body;
      this.template = data;
    },
    editorLoaded() {
      this.editor.loadDesign(this.template.design);

      // MLD-2949
      // @see https://docs.unlayer.com/docs/user-uploads#custom-database
      this.editor.registerProvider('userUploads', async (params, done) => {
        done(this.images);
      });

      /*this.editor.registerCallback('selectImage', async (data, done) => {
        this.mediaDoneCallback = done;
        this.mediaDialog = true;
      })*/

      // MLD-2949 Image Upload Callback
      // @see https://docs.unlayer.com/docs/custom-file-storage#image-upload-callback
      this.editor.registerCallback('image', async (file, done) => {
        const path = '/unlayer_images';
        const urls = await teamAssetService.upload([file.attachments[0]], path);
        if (isArray(urls) && urls.length) {
          const url = urls[0];
          done({
            progress: 100,
            url: url,
          });
        }
      });

      // MLD-2949 Image Delete Callback
      // @see https://docs.unlayer.com/docs/user-uploads#handling-deletions
      this.editor.registerCallback('image:removed', async (params, done) => {
        alert('You cannot delete images from here. Go to Team Settings > Public Files instead.');
        //done();
      })
    },
    imageSelected(image) {
      this.mediaDialog = false;
      this.mediaDoneCallback({url: image.location});
      this.mediaDoneCallback = null;
    },
    async updateFromDesign() {
      console.log('updateFromDesign');
      await this.editor.exportHtml(async data => {
        this.form.design = data.design;
        this.form.html_body = data.html;
      });
    },
    async copyJSON() {
      this.editor.saveDesign(async design => {
        await clipboardService.copy(JSON.stringify(design, null, 4));
        this.$toast.success('The design was copied to your clipboard.');
      })
    },
    async downloadJSON() {
      this.editor.saveDesign(async design => {
        await shareTemplateService.downloadJSON(this.template, design, this.downloadFilename);
      });
    },
    async copyHTML() {
      this.editor.exportHtml(async data => {
        await clipboardService.copy(data.html, true);
        this.$toast.success('The HTML was copied to your clipboard.');
      });
    },
    async downloadHTML() {
      this.editor.exportHtml(async data => {
        await shareTemplateService.downloadHTML(data.html, this.downloadFilename);
      });
    },
    async downloadPDF() { // MLD-7683
      await shareTemplateService.downloadPDF(this.template, {});
    },
    async saveDesign() {
      if (this.form.busy) {
        return;
      }
      this.form.startProcessing();
      try {
        this.editor.exportHtml(async data => {
          this.form.design = data.design;
          this.form.html_body = data.html;
          this.editor.exportPlainText(data => { // MLD-3703 this function may have to be removed because it might break the Liquid template tags.
            this.form.text_body = data.text;
            shareTemplateService.updateDesign(this.template.id, this.form.data())
              .then(() => {
                this.$toast.success('Template saved.');
                this.form.finishProcessing();
              })
          });
        })
      } catch (err) { // MLD-7175
        this.form.handleErrors(err);
        this.$toast.error('The template could not be saved. Please make a small edit and then try again. Contact support@mobilelocker.com if the problem persists.');
      } finally {
        this.form.busy = false;
      }
    },
    showUploadDialog() { // MLD-6456
      this.uploadDialog = true;
    },
    closeUploadDialog() { // MLD-6456
      this.uploadDialog = false;
    },
    async uploadJSON() { // MLD-6456
      if (!this.uploadForm.file) {
        return;
      }
      try {
        this.uploadForm.startProcessing();
        const fileContent = await fileUploadService.readFileContent(this.uploadForm.file);
        this.editor.loadDesign(JSON.parse(fileContent));
        await this.saveDesign();
        this.uploadForm.finishProcessing();
        this.uploadForm.reset();
        this.closeUploadDialog();
      } catch (e) {
        this.uploadForm.errors.set(e);
      } finally {
        this.uploadForm.busy = false;
      }
      /*const form = {
        design: JSON.parse(fileContent),
      }
      shareTemplateService.updateDesign(this.template.id, form)
        .then(data => {
          this.$toast.success('Template saved.');
          this.setTemplateFromData(data);
          this.editor.loadDesign(this.template.design);
          this.uploadForm.finishProcessing();
        })
        .catch(err => {

        })
        .finally(() => {
          this.uploadForm.busy = false;
        })*/
    },
  }
}
</script>
